// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"onfido-sdk-ui-Complete-wrapper","icon":"onfido-sdk-ui-Complete-icon"};